import { createAction, props } from "@ngrx/store";
import { BlackBoxEntry } from "src/model/class/general classes/black-box-entry";
import { Building } from "src/components/shared-components/class/general-classes/building";
import {
  BlackBoxStoreAction,
  BuildingStoreAction,
} from "src/components/shared-components/enum/enumStoreAction";

/**
 * Action delete notification complete
 */
export const blackBoxAddEntry = createAction(
  BlackBoxStoreAction.BLACK_BOX_INSERT_ENTRY,
  props<{ insertEntry: BlackBoxEntry; numberEvents: number }>()
);

/**
 * BlackBox remove entry
 */
export const blackBoxRemoveEntry = createAction(
  BlackBoxStoreAction.BLACK_BOX_REMOVE_ENTRY,
  props<{ numberEvents: number }>()
);

/**
 * BlackBox remove all entry
 */
export const blackBoxRemoveAllEntry = createAction(
  BlackBoxStoreAction.BLACK_BOX_REMOVE_ALL_ENTRY
);
